const SITE_ENVIRONMENTS = {
    CONVATEC_CLUB_JP: [
        'convatec-club.jp',
        'cvtclub-dev.dxp.convatec.com',
        'cvtclub-uat.dxp.convatec.com',
    ],
};

export { SITE_ENVIRONMENTS };
